// import permissions from "constants/permissions";
import { gql } from '@apollo/client';
import { useQueryWithErrorHandling } from './errorHandling';
// import { includes } from "ramda";

// const { viewSettings } = permissions;
const GET_USER_DATA = gql`
  query userData($externalId: ID!) {
    userData(externalId: $externalId) {
      id
      userName
      userGroups {
        id
        name
        dashboardIds
      }
    }
  }
`;

export function useUserData(user) {
  // const { oidcUser } = useReactOidc();
  const externalUserId = user?.profile?.sub;

  const { data, ...res } = useQueryWithErrorHandling(GET_USER_DATA, {
    variables: {
      externalId: externalUserId
    },
    skip: !externalUserId
  });
  return { ...res, userData: data?.userData };
}
